import React from 'react';
import { Icon, Text } from 'vkit/lib/components';
import Colors from '@/shared/entities/types/colors.type';
import classesBuilder from '@/utils/classesBuilder';
import style from './style/alertMessage.module.scss';

export interface AlertMessageProps {
  title?: string;
  message?: string;
  color?: Colors;
  icon?: string;
}

const AlertMessage: React.FC<AlertMessageProps> = ({
  title,
  message,
  color = 'colorDefault',
  icon,
}) => (
  <div
    className={classesBuilder(style, {
      alertMessage: true,
      [color]: true,
    })}>
    {icon && (
      <div className={style.icon}>
        <Icon color={color} name={icon} size={20} />
      </div>
    )}

    <div className={style.content}>
      {title && <Text title color={color} size='minor' value={title} />}

      {message && <Text color={color} size='medium' value={message} />}
    </div>
  </div>
);

export default AlertMessage;
